import React, { Component } from 'react';
import HomePage from './components/homepage/HomePage';

export default class App extends Component {

  render() {
    return (
      <div className="App">
        <HomePage />
      </div>
    );
  }
}
